import TramiteFormView from 'src/components/views/EscritosLexnet/components/Tramite/TramiteFormView'
import SubmitForm from 'src/components/views/EscritosLexnet/components/shared/components/SubmitForm'

type TramiteFormPropsTyps = {
  section: string
}

function TramiteForm({ section }: TramiteFormPropsTyps): JSX.Element {
  return (
    <SubmitForm>
      <TramiteFormView section={section} />
    </SubmitForm>
  )
}

export default TramiteForm
